import * as React from 'react';

import useInterval from '@/hooks/use-interval';

type DisplayedOpacity = number | null;

export function useTrackedOpacity(
  initialOpacity: number,
  elementRef: React.RefObject<HTMLElement>,
  isRendered: boolean
) {
  const [displayedOpacity, setDisplayedOpacity] =
    React.useState<DisplayedOpacity>(initialOpacity);

  React.useEffect(() => {
    if (!isRendered) {
      setDisplayedOpacity(null);
    }
  }, [isRendered]);

  useInterval(() => {
    if (!isRendered || !elementRef.current) {
      return;
    }

    const opacity = getComputedStyle(elementRef.current).opacity;

    setDisplayedOpacity(Number(opacity));
  }, 50);

  return displayedOpacity;
}
